import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=28b4c1b6&scoped=true&"
import script from "./indexPage.vue?vue&type=script&lang=js&"
export * from "./indexPage.vue?vue&type=script&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=28b4c1b6&lang=scss&scoped=true&"
import style1 from "./indexPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4c1b6",
  null
  
)

export default component.exports